import { CustomerRemoteInfo } from '@@types'
import { gql, useLazyQuery, useQuery } from '@apollo/client'

/**
 * GraphQL запрос для проверки авторизации пользователя
 * Аналог useFetchPingAuth из customer-app
 */
export const GQL_QUERY_PING_AUTH = gql`
  query pingAuth {
    pingAuth {
      id
      status
      first_name
      last_name
      phone
      receipt_email

      requireRegistration
      
      email
      isEmailVerified
      new_email
      secondsBeforeDeletion
    }
  }
`

type PingAuthQueryResult = {
  pingAuth: CustomerRemoteInfo | null
}

export const useFetchPingAuth = () => {
  const { data, loading, error, refetch } = useQuery<PingAuthQueryResult>(GQL_QUERY_PING_AUTH)

  const customer = data?.pingAuth ?? null

  return {
    data,
    customer,
    loading,
    error,
    refetch,
  }
}

export const useLazyFetchPingAuth = () => {
  const [ fetch, { data, loading, error, refetch } ] = useLazyQuery<PingAuthQueryResult>(GQL_QUERY_PING_AUTH)

  const customer = data?.pingAuth ?? null

  return {
    fetch,
    data,
    customer,
    loading,
    error,
    refetch,
  }
}

export type { PingAuthQueryResult }
